
import React from 'react';
import { MultiValue, useEntity} from 'react-admin-base';
import { SingleFilePicker, EntityEditor, CheckBox, ImagePicker } from 'react-admin-base-bootstrap';
import { Col, Container, Input, Row } from "reactstrap";
import MultiSelectCheck from "../Components/MultiSelectCheck";
import { Step, StepLayout } from "../Components/Step";

import JobStatuses from '../data/job_status.json';
import CommTools from '../data/commtools.json';
import Levels from '../data/levels.json';
import SelfAsses from "../Components/SelfAsses";
import Topics from "../data/topics.json";
import Sports from "../data/sports.json";
import {useUser} from "../Components/UserProvider";
import LogoutBox from "../Components/LogoutBox";
import Field from "../Components/Field";
import FancyEntityEditor from '../Components/FancyEntityEditor';
import { FormattedMessage } from 'react-intl';

export default function Mentor() {
    const user = useUser();
    return <MentorEdit id={user.id} />;
}

export function MentorEdit({ id }) {
    const entity = useEntity('/mentor', id, { user: {} });
    const [ data, setData, ,loading ] = entity;

    return <FancyEntityEditor entity={entity}>
        <StepLayout saveOnLastStep={!data.user.id}>
            <Step translate="PROFILE_INFORMATION">
                <Field translate="PROFILE_PHOTO" type="required">
                    <ImagePicker
                        value={data.user.avatar || ''}
                        onChange={a => setData({ user: { ...(data.user || {}), avatar: a } })}
                        width="512"
                        height="512"
                        type="png"
                    />
                </Field>
                <Field translate="COVER_PHOTO">
                    <ImagePicker
                        value={data.user.cover || ''}
                        onChange={a => setData({ user: { ...(data.user || {}), cover: a } })}
                        width="1000"
                        height="250"
                        type="jpg"
                    />
                </Field>
                <Field translate="ABOUT" type="required">
                    <Input
                        type="textarea"
                        rows={6}
                        value={data.about || ''}
                        onChange={a => setData({ about: a.currentTarget.value })}
                    />
                </Field>
                <Field translate="LINKEDIN_PROFILE" type="url">
                    <Input
                        type="text"
                        value={data.linkedin_profile || ''}
                        onChange={a => setData({ linkedin_profile: a.currentTarget.value })}
                    />
                </Field>
            </Step>
            <Step translate="BACKGROUND">
                {/*<Field title="What is your educational background?">

                </Field>*/}
                <Field translate="JOB_TITLE">
                    <MultiSelectCheck
                        id="job"
                        value={data.job_ids || []}
                        onChange={a => setData({ job_ids: a })}
                        fields={JobStatuses}
                    />
                </Field>
                <Field translate="YEARS_OF_EXPERTISE" type="numeric|required">
                    <Input
                        type="text"
                        value={data.years_of_experience || ''}
                        onChange={a => setData({ years_of_experience: a.currentTarget.value })}
                    />
                </Field>
                <Field translate="WHY_USE_APP" type="required">
                    <Input
                        type="textarea"
                        rows={6}
                        value={data.reason || ''}
                        onChange={a => setData({ reason: a.currentTarget.value })}
                    />
                </Field>
                <Field translate="COMMUNICATION_TOOLS">
                    <MultiSelectCheck
                        id="tools"
                        value={data.tool_ids || []}
                        onChange={a => setData({ tool_ids: a })}
                        fields={CommTools}
                    />
                </Field>
            </Step>

            <Step translate="VIDEOS">
                <p><FormattedMessage id="VIDEOS_DESC" /></p>
                <MultipleUploader
                    title="Video"
                    accepts="video/*"
                    value={data.videos}
                    onChange={videos => setData({ videos })}
                />
            </Step>

            <Step translate="PRESENTATIONS">
                <p><FormattedMessage id="PRESENTATION_DESC" /></p>
                <MultipleUploader
                    title="Presentation"
                    accepts="*/*"
                    value={data.presentations}
                    onChange={presentations => setData({ presentations })}
                />
            </Step>

            <Step translate="SELF_ASSESSMENT">
                <Field translate="SELF_ASSESS_SKILLS">
                    <SelfAsses
                        value={data.assessments}
                        onChange={a => setData({ assessments: a })}
                        fields={Sports}
                    />
                </Field>
                <Field translate="SELF_ASSESS_TOPICS">
                    <SelfAsses
                        value={data.assessments}
                        onChange={a => setData({ assessments: a })}
                        fields={Topics}
                    />
                </Field>
            </Step>
            <Step translate="FOCUSED_AREAS">
                <Field translate="FOCUS_AREAS_MENTOR" type="required">
                    <MultiSelectCheck
                        id="levels"
                        value={data.focus_area_ids || ''}
                        onChange={a => setData({ focus_area_ids: a })}
                        fields={Levels}
                    />
                </Field>
            </Step>
            
            <Step translate="VOLUNTEERING">
                <Field>
                    <CheckBox
                        id="volunteering"
                        type="checkbox"
                        checked={!!data.volunteering}
                        onChange={a => setData({ volunteering: !data.volunteering })}
                    >
                        <FormattedMessage id="VOLUNTEERING_CHECK" />
                    </CheckBox>
                </Field>
            </Step>
        </StepLayout>
    </FancyEntityEditor>;
}

/*
<Step title="Availability">
    <AvailabilitySelect
        value={data.availabily || []}
        onChange={availabily => setData({ availabily })}
    />
</Step>
<Step title="Pricing">
    <Field title="Price per hour (in Euros)" type="numberic">
        <Input
            type="text"
            value={data.price || ''}
            onChange={a => setData({ price: a.currentTarget.value })}
        />
    </Field>
</Step>
*/

function MultipleUploader({ title, accepts, value, onChange }) {
    return <MultiValue value={value} add onChange={onChange}>
        {
            (value, onChange, index) => <Row>
                <Col md="4">
                    <Field title={title + " #" + (index + 1)} type={value && 'required'}>
                        <SingleFilePicker
                            accepts={accepts}
                            value={(value && value.file) || null}
                            onChange={file => onChange((file && { ...value, file }) || null)}
                        />
                    </Field>
                </Col>
                <Col md="8">
                    <Field title="Title" type={value && 'required'}>
                        <Input
                            disabled={value === null}
                            type="text"
                            value={(value && value.title) || ''}
                            onChange={a => onChange({ ...value, title: a.currentTarget.value })}
                        />
                    </Field>
                    <Field title="Description">
                        <Input
                            disabled={value === null}
                            type="textarea"
                            rows={3}
                            value={(value && value.description) || ''}
                            onChange={a => onChange({ ...value, description: a.currentTarget.value })}
                        />
                    </Field>
                </Col>
            </Row>
        }
    </MultiValue>;
}

